import React from 'react';

import FacebookFeed from 'src/components/common/facebook-feed';
import FirstScreen from './components/first-screen';
import Info from './components/info';
import Reviews from './components/reviews';
import Team from './components/team';

import useWindowSize from 'src/hooks/use-window-size';
import {
  FACEBOOK_FEED_DEPRECATED,
  FACEBOOK_FEED_ENABLED,
  FACEBOOK_FEED_HEIGHT,
  FACEBOOK_FEED_HEIGHT_TO_WIDTH_RATIO,
  FACEBOOK_FEED_MAX_WIDTH,
  FACEBOOK_FEED_SCREEN_HEIGHT_MAX_QUOTA,
} from 'src/constants';

import './main-page.scss';

const MainPage = () => {
  const { height, width } = useWindowSize();
  const feedHeight = Math.ceil(
    Math.min(
      FACEBOOK_FEED_HEIGHT,
      width > FACEBOOK_FEED_MAX_WIDTH ? height : height * FACEBOOK_FEED_SCREEN_HEIGHT_MAX_QUOTA,
      width * FACEBOOK_FEED_HEIGHT_TO_WIDTH_RATIO
    )
  );

  return (
    <div className="main-page">
      <FirstScreen />
      <div className="main-page__team-review">
        <Team />
        <Reviews />
      </div>
      {FACEBOOK_FEED_ENABLED && window.FACEBOOK_PAGE_URL && (
        <FacebookFeed
          height={feedHeight}
          href={window.FACEBOOK_PAGE_URL}
          isDeprecatedVersion={FACEBOOK_FEED_DEPRECATED}
          language="he_IL"
          width={width}
        />
      )}
      <Info />
    </div>
  );
};

export default MainPage;
